// extracted by mini-css-extract-plugin
export var accent = "_2d-4";
export var add = "_2d-j";
export var addIcon = "_2d-k";
export var deleteIcon = "_2d-i";
export var disabled = "_2d-9";
export var ellipsis = "_2d-f";
export var error = "_2d-3";
export var form = "_2d-5";
export var hideFocus = "_2d-2";
export var icon = "_2d-7";
export var input = "_2d-e";
export var listItem = "_2d-h";
export var mediumHeight = "_2d-b";
export var noBorder = "_2d-8";
export var noRadius = "_2d-1";
export var shortHeight = "_2d-a";
export var tallHeight = "_2d-c";
export var textInput = "_2d-0";
export var vertical = "_2d-g";
export var veryTallHeight = "_2d-d";
export var widget = "_2d-6";